<template>
  <figure
    v-if="src"
    class="video has-loading-transition"
    :class="{ 'is-visible': visible }"
  >
    <video
      v-if="src"
      ref="video"
      class="has-ratio"
      autoplay
      muted
      loop
      playsinline
      @loadeddata="onPlay"
      @play="onPlay"
      @playing="onPlay"
    >
      <source
        v-if="srcMobile"
        :src="srcMobile"
        :type="type"
        media="(max-width: 768px)"
      />
      <source v-if="src" :src="src" :type="typeMobile" />
    </video>
  </figure>
</template>

<script lang="ts" setup>
import type { MediaVideoFragment } from '#graphql-operations'

const props = defineProps<{
  file?: MediaVideoFragment['file']
  fileMobile?: MediaVideoFragment['fileMobile']
}>()

const video = ref<HTMLVideoElement>()
const visible = ref(false)

const src = computed(() => props.file?.entity?.url?.path || '')
const srcMobile = computed(() => props.fileMobile?.entity?.url?.path || '')
const type = computed(() => props.file?.entity?.filemime || '')
const typeMobile = computed(() => props.fileMobile?.entity?.filemime || '')

onMounted(() => {
  /* Previous version:
 if (this.video) {
   if (this.video.readyState !== 0) {
     this.visible = true
   }
 }
 */
  if (video.value && video.value.readyState !== 0) {
    visible.value = true
  }
})

function onPlay() {
  visible.value = true
}

// Exposing methods for external use
defineExpose({
  play: () => video.value?.play(),
  pause: () => video.value?.pause(),
})
</script>

<style lang="postcss">
.video {
  background: $image-loading-background;
  &.has-loading-transition {
    opacity: 0.04;
    transition: 0.8s;
    &.is-visible {
      opacity: 1;
    }
  }

  video {
    width: 100%;
    display: block;
    background: $image-loading-background;
  }
  video::-webkit-media-controls-start-playback-button {
    display: none;
  }
}
</style>
